import HardwareCounter from './HardwareCounter';

export default HardwareCounter
